import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, Routes, UrlTree } from '@angular/router';
import { LoginComponent } from './Pages/login/login.component';
import { AppComponent } from './app.component';
import { HomeComponent } from './Pages/home/home.component';
import { StorageService } from '../services/storage.service';
import { inject } from '@angular/core';

export const canActivate: (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot) => boolean | UrlTree = (route, state) => {
    const authService = inject(StorageService);
    const router = inject(Router);

    if (authService.getStoredUser()) {
      return true;
    }
    else {
      return router.parseUrl('/login')
    }
  }

// export const canRedirect: (
//   route: ActivatedRouteSnapshot,
//   state: RouterStateSnapshot) => boolean | UrlTree = (route, state) => {
//     const authService = inject(StorageService);
//     const router = inject(Router);
//     if (authService.getStoredUser()) {
//       return router.parseUrl('/Terminal')
//     }
//     else {
//       return router.parseUrl('/login')
//     }
//   }

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'Terminal',
    canActivate: [canActivate],
    component: HomeComponent
  },
];
